/**
 * When buy-2 or pick-10 campaigns are active, discount codes must not apply.
 * Liquid hides the field; this script clears any code already on the cart
 * (URL, previous visit, or a code applied before the cart qualified).
 */
(() => {
  const STATE_SELECTOR = '[data-mm-campaign-discount-state]';
  const nativeFetch = window.fetch.bind(window);
  const root = () => window.Shopify?.routes?.root || '/';

  let clearing = false;
  let clearAttempts = 0;
  const MAX_CLEAR_ATTEMPTS = 3;

  function readBlocked() {
    const nodes = document.querySelectorAll(STATE_SELECTOR);
    for (let i = 0; i < nodes.length; i += 1) {
      try {
        const data = JSON.parse(nodes[i].textContent || '{}');
        if (data.blocked === true) return true;
      } catch (error) {
        /* ignore malformed state */
      }
    }

    return Boolean(document.querySelector('[data-mm-campaign-blocks-discounts="true"]'));
  }

  function applicableCodes(cart) {
    return (cart?.discount_codes || []).filter((discount) => discount && discount.applicable && discount.code);
  }

  async function fetchCart() {
    const response = await nativeFetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    return response.json();
  }

  async function clearDiscountCodes() {
    if (clearing || !readBlocked() || clearAttempts >= MAX_CLEAR_ATTEMPTS) return;

    const cart = await fetchCart();
    if (!cart) return;

    const codes = applicableCodes(cart);
    if (!codes.length) {
      clearAttempts = 0;
      return;
    }

    clearing = true;
    clearAttempts += 1;
    try {
      const response = await nativeFetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ discount: '' }),
      });

      if (response.ok) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
        }
      }
    } finally {
      clearing = false;
    }
  }

  function blockNewCodes(event) {
    if (!readBlocked()) return;
    const field = event.target && event.target.closest && event.target.closest('cart-discount-field');
    if (!field) return;

    event.stopImmediatePropagation();
    event.preventDefault();
    clearDiscountCodes();
  }

  document.addEventListener('change', blockNewCodes, true);
  document.addEventListener('cart:refresh', () => {
    window.setTimeout(clearDiscountCodes, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearDiscountCodes);
  } else {
    clearDiscountCodes();
  }
})();
